import {
  CashRegisterStrokeIcon,
  PeopleIcon,
  SiteIcon,
  CalendarIcon,
  PieGraphIcon,
  CommandIcon,
  TabletIcon,
  DocumentIcon,
  MedalIcon,
  QuestionMarkIcon,
} from "../../models/icons";
import {
  BOOKING_ROUTE,
  CASH_REGISTER,
  CLIENTS_ROUTE,
  STATISTICS_ROUTE,
  ANALYTICS_ROUTE,
  COMANDAS_ROUTE,
  COMANDA_TABLET_ROUTE,
  CERTIFICATE_ROUTE,
  HELP_CENTER_ROUTE,
} from "../../models/localPath";

export const businessList = (navigate: (path: string) => void) => [
  {
    itemLabel: "Caja",
    itemSvg: CashRegisterStrokeIcon,
    onItemSelected: () => navigate(CASH_REGISTER),
    accessId: "f363f59b-20e8-481d-83d1-72231191fbf3",
  },
  {
    itemLabel: "Reservas",
    itemSvg: CalendarIcon,
    onItemSelected: () => navigate(BOOKING_ROUTE),
    accessId: "48bc617b-199b-4f25-9b15-d84da7be03b3",
  },
  {
    itemLabel: "Comandas",
    itemSvg: CommandIcon,
    onItemSelected: () => navigate(COMANDAS_ROUTE),
    accessId: "b3d8f9a2-5455-44b4-be00-62f19793b1c1",
  },
  {
    itemLabel: "Toma de Pedidos",
    itemSvg: TabletIcon,
    onItemSelected: () => navigate(COMANDA_TABLET_ROUTE),
    accessId: "7405e06e-90a0-436a-b3b7-88e89e5feb9c",
  },
  {
    itemLabel: "Clientes",
    itemSvg: PeopleIcon,
    onItemSelected: () => navigate(CLIENTS_ROUTE),
    accessId: "2e5bb676-f25c-4cd3-8897-de15782f37ba",
  },
  {
    itemLabel: "Estadísticas",
    itemSvg: SiteIcon,
    onItemSelected: () => navigate(STATISTICS_ROUTE),
    accessId: "73d1b54a-3293-4325-9838-13beef01fa60",
  },
  {
    itemLabel: "Explorador",
    itemSvg: PieGraphIcon,
    onItemSelected: () => navigate(ANALYTICS_ROUTE),
    accessId: "5d6ff83a-9bb0-4e98-bdc6-59b44b891b09",
  },
  // 038 Fidelización (Prikly Pass) se movió al menú de la derecha (perfil →
  // «Gestionar mi negocio», profile/consts.tsx) con candado de add-on.
  {
    // 009 LMS Certifícate: sin accessId a propósito — todo empleado puede capacitarse
    itemLabel: "Certifícate",
    itemSvg: MedalIcon,
    onItemSelected: () => navigate(CERTIFICATE_ROUTE),
    accessId: "",
  },
  {
    // 014 Centro de ayuda: sin accessId — disponible para todo usuario autenticado
    itemLabel: "Centro de ayuda",
    itemSvg: QuestionMarkIcon,
    onItemSelected: () => navigate(HELP_CENTER_ROUTE),
    accessId: "",
  },
];
